import { createMemoStyles } from '@wds/styles';

export default createMemoStyles({
  ViewPricingLink: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 14,
    '& svg': {
      marginLeft: 3,
    },
  },
});
